'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = t;

var _ = require('..');

var config = _.CaligramReact.config();

function t(key) {
  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var translations = config.locales[config.locale];
  var nestedKeys = key.split('.');
  var nextObject = translations;
  var nextKey = void 0;

  if (!translations) {
    throw new Error('Locale \'' + config.locale + '\' does not exist in caligram-react config');
  }

  while (nestedKeys.length > 0) {
    nextKey = nestedKeys.shift();
    nextObject = nextObject[nextKey];
  }

  if (typeof nextObject !== 'string') {
    throw new Error('Key \'' + key + '\' does not exist for locale \'' + config.locale + '\' in caligram-react config');
  }

  var translation = nextObject;
  var pluralForms = translation.split(' |||| ');

  if (pluralForms.length > 1) {
    if (count > 1) {
      return pluralForms[1];
    }
    return pluralForms[0];
  }

  return translation;
}


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/helpers/i18n.js
// module id = 74
// module chunks = 0